import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { situations, growthPath } from '../../data/content';
export function Situation() {
  return <section className="bg-mist py-12 lg:py-20" aria-labelledby="situation-title" data-id="element-420" data-mp="31whlkxnykyqi">
      <div className="mx-auto max-w-5xl px-5" data-id="element-421" data-mp="2nyt1hs1ptvmi">
        <div className="mx-auto max-w-3xl text-center" data-id="element-422" data-mp="2sxmc9cpmb8iz">
          <h2 id="situation-title" className="font-display text-[26px] font-extrabold leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-423" data-mp="2t08jtccido17">
            ¿En qué situación estás hoy?
          </h2>
          <p className="mt-2 text-[15px] font-semibold leading-relaxed text-ink-soft sm:text-lg" data-id="element-424" data-mp="2j19di0f7u4hd">
            No importa si estás dando tus primeros pasos o si ya trabajás con personas mayores.
          </p>
        </div>

        <ul className="mt-8 grid gap-4 md:grid-cols-2 md:gap-5 lg:mt-10" data-id="element-425" data-mp="1vadlp3arf9a4">
          {situations.map((s, i) => {
          const Icon = s.icon;
          const dark = i === 1;
          return <li key={s.title} className={`flex flex-col rounded-3xl p-5 sm:p-7 ${dark ? 'bg-brand-950 text-white' : 'bg-white text-ink ring-1 ring-brand-100'}`} style={{
            backgroundColor: "#5CD2B4",
            backgroundImage: "none"
          }} data-id="element-426" data-mp="2vwihopabjinb" data-mpi={i}>
                <div className="flex items-center gap-3" data-id="element-427" data-mp="34xghswhmz60m">
                  <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl ${dark ? 'bg-white/10 text-white' : 'bg-brand-50 text-brand-600'}`} data-id="element-428" data-mp="34uub0z2kkujg">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-429" data-mp="2d6iwweligppp" />
                  </span>
                  <h3 className="font-display text-xl font-extrabold uppercase leading-tight tracking-tight sm:text-2xl" style={{
                fontSize: "24px",
                fontWeight: "900",
                textAlign: "left",
                color: "#174A5B"
              }} data-id="element-430" data-mp="288hbhn0m4eb2">{s.title}</h3>
                </div>
                <p className={`mt-4 text-[15px] font-semibold leading-relaxed ${dark ? 'text-white' : 'text-ink'}`} style={{
              color: "#FBFAEB"
            }} data-id="element-431" data-mp="1ti0c097jfygt">“{s.lead}”</p>
                <p className={`mt-2 text-sm leading-relaxed ${dark ? 'text-brand-100' : 'text-ink-soft'}`} style={{
              color: "#090A0A"
            }} data-id="element-432" data-mp="1pfwx1alnubqs">{s.body}</p>
                <p className={`mt-auto flex items-start gap-2 pt-5 font-display text-sm font-extrabold uppercase leading-snug tracking-wide ${dark ? 'text-sun' : 'text-brand-600'}`} style={{
              color: "#0E2D47"
            }} data-id="element-433" data-mp="3tjzuu5xoznsh">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0" strokeWidth={3} aria-hidden="true" data-id="element-434" data-mp="7580u9l7mp74" />
                  {s.highlight}
                </p>
              </li>;
        })}
        </ul>

        <div className="mt-8 text-center lg:mt-10" data-id="element-435" data-mp="3aklxrf4o1wxr">
          <p className="text-sm font-bold uppercase tracking-wider text-ink-soft" data-id="element-436" data-mp="3anhwv6s92rns">En ambos casos, el objetivo es el mismo:</p>
          <p className="mx-auto mt-1 max-w-2xl font-display text-xl font-extrabold leading-tight text-ink sm:text-2xl" data-id="element-437" data-mp="3kjbhzek1bth6">
            Brindarte  herramientas para  <span className="text-brand-600" data-id="element-438" data-mp="utre73j49s62">trabajar con personas mayores.</span>
          </p>

          <ol className="mx-auto mt-6 flex max-w-4xl flex-wrap items-center justify-center gap-x-1.5 gap-y-2" aria-label="Tu recorrido" data-id="element-439" data-mp="zrsujgp5rddu">
            {growthPath.map((step, i) => <li key={step} className="flex items-center gap-1.5" data-id="element-440" data-mp="2fdd0ctq8glxt" data-mpi={i}>
                <span className={`whitespace-nowrap rounded-full px-3 py-1.5 font-display text-xs font-extrabold uppercase tracking-wide sm:text-[13px] ${i === growthPath.length - 1 ? 'bg-brand-600 text-white' : 'bg-white text-ink ring-1 ring-brand-100'}`} style={{
              color: "#17313B",
              backgroundColor: "#54E8ED",
              backgroundImage: "none"
            }} data-id="element-441" data-mp="2albm529i8l55">
                  {step}
                </span>
                {i < growthPath.length - 1 && <ArrowRightIcon className="h-3.5 w-3.5 text-brand-600" aria-hidden="true" data-id="element-442" data-mp="1rlxtcnnihgg8" />}
              </li>)}
          </ol>
        </div>
      </div>
    </section>;
}